import { ArrowRight } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

export const BookButton = ({
  className = "",
  testid = "book-cta",
  label = "Book a Consultation",
}) => (
  <button
    data-testid={testid}
    onClick={() => scrollToSection("#contact", "Consultation")}
    className={`group relative overflow-hidden rounded-full bg-cyan-300 px-6 py-3 font-display text-sm font-bold text-[#05080F] transition-shadow duration-300 hover:shadow-[0_0_44px_rgba(0,240,255,0.4)] ${className}`}
  >
    <span className="relative z-10 flex items-center justify-center gap-2">
      {label}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
    </span>
    <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-emerald-300 to-cyan-200 transition-transform duration-500 ease-out group-hover:translate-x-0" />
  </button>
);
